export default __webpack_public_path__ + "static/media/San-hwan.bc9f22ef.png";